import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import { FilterModalModule } from '@helios/filter-modal'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { RowActionsModule, TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  CheckboxModule,
  NfFormsModule,
  TableModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { CustomNoRowsOverlayComponent } from './custom-overlay/custom-no-rows-overlay.component'
import { ExternalComparisonPanelComponent } from './external-comparison/external-comparison-panel.component'
import { ExternalPositionDetailPanelComponent } from './external-position-detail/external-position-detail-panel.component'
import { HistoricalBalanceComparisonPanelComponent } from './historical-balance-comparison/historical-balance-comparison-panel.component'
import { PositionExchangeErrorComponent } from './modals/position-exchange-error/position-exchange-error.component'
import { PositionsGridComponent } from './positions-grid/positions-grid.component'
import { PositionsPanelComponent } from './positions-panel.component'
import { HttpPositionsService } from './services/http-positions.service'
import { PositionsService } from './services/positions.service'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    GenericComponentsModule,
    RowActionsModule,
    NgbNavModule,
    TableModule,
    FormsModule,
    ToggleModule,
    ReactiveFormsModule,
    ResizeHandleModule,
    NfFormsModule,
    CheckboxModule,
    NgbTooltipModule,
    FilterModalModule,
    NgbDropdownModule,
    CommentsModule,
  ],
  declarations: [
    PositionsPanelComponent,
    PositionsGridComponent,
    HistoricalBalanceComparisonPanelComponent,
    ExternalComparisonPanelComponent,
    PositionExchangeErrorComponent,
    CustomNoRowsOverlayComponent,
    ExternalPositionDetailPanelComponent,
  ],
  exports: [
    PositionsPanelComponent,
    PositionsGridComponent,
    HistoricalBalanceComparisonPanelComponent,
    ExternalComparisonPanelComponent,
    ExternalPositionDetailPanelComponent,
  ],
  providers: [{ provide: PositionsService, useClass: HttpPositionsService }],
})
export class PositionsModule {}

export { PositionsPanelComponent }
